import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const UserIcon = createIcon({
  displayName: 'UserIcon',
  path: [
    <path
      d='M20 22H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v2Zm-8-9A6 6 0 1 1 12 .998 6 6 0 0 1 12 13Z'
      fill='currentColor'
    />
  ],
  defaultProps: defaultProps
})
